import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormArray, FormControl, Form, FormBuilder, Validators } from '@angular/forms';



import {apiUrl}  from '../global';
import { ResponseApi } from '../response-api';
import { LoginGameService } from '../login-game.service';
import { SharedService } from '../shared.service';

function validateEmail(c: FormControl) {
  let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

  return EMAIL_REGEXP.test(c.value) ? null : {
    validateEmail: {
      valid: false
    }
  };
}

@Component({
  selector: 'login',
  templateUrl: 'login-game.component.html',
  styleUrls: ['login-game.component.css'],
})
export class LoginGameComponent implements OnInit {
  responseApis: ResponseApi[];
  loginAttempt: ResponseApi[];
  error: any;
  backgroundColor: string;
  fadeOutLoader: boolean;
  fadeOutLoaderLogin: boolean;
  logo: any;
  domainList: any;
  userListType: boolean;
  hasUserList: boolean;
  form: any;
  attemptToSubmit: boolean;
  showLoaderLogin: boolean;
  textError: string;
  identifierForServer: string;
  firstIndex: any;


  constructor(private router: Router, private loginService: LoginGameService, private route: ActivatedRoute, private sharedService: SharedService) {
    this.attemptToSubmit = true;

    this.fadeOutLoaderLogin = false;
    this.showLoaderLogin = false;

    this.textError = "";
  }
  setBackgroundColor(backgroundColor: string):void{
    this.sharedService.setBackgroundColor(backgroundColor);
  }
  getBackgroundColor(){
    return this.sharedService.getVal('backgroundColor');
  }
  getUrl(url: string): void {
    this.loginService
      .getUrl(url)
      .then(responseApi => {
        this.responseApis = responseApi;
        if(this.responseApis['success'] == false){
          this.router.navigate(['page-not-found']);
        }
        else{
          var domain = this.responseApis[0]['data']['generalDetails'][0]['has_domain'];
          var userListType = this.responseApis[0]['data']['generalDetails'][0]['user_list_type'];
          var hasUserList = this.responseApis[0]['data']['generalDetails'][0]['has_user_list'];
          var firstQuestionForUser = this.responseApis[0]['data']['questions'];
          var firstIndex = 0;
          for(var i = 0; i<firstQuestionForUser.length; i++){
            if(i == 0){
              firstIndex = firstQuestionForUser[i]['order_in_quiz'];
            }
            else{
              if(firstQuestionForUser[i]['order_in_quiz']<firstIndex){
                firstIndex = firstQuestionForUser[i]['order_in_quiz'];
              }
            }
          }
          this.firstIndex = firstIndex;

          if(domain == 1){
            this.domainList = this.responseApis[0]['data']['domains'];
          }
          else{
            this.domainList = false;
          }

          if(userListType == 'email'){
            this.userListType = true;
          }
          else{
            this.userListType = false;
          }

          if(hasUserList == 1){
            this.hasUserList = true;
          }
          else{
            this.hasUserList = false;
          }


          //has list - email
          if(this.hasUserList && this.userListType){
            this.form = new FormGroup({
              email: new FormControl('', validateEmail)
            });
          }

          //has list - no email, email not mandatory
          else if(this.hasUserList && !this.userListType){
            this.form = new FormGroup({
              identifier: new FormControl('', Validators.required),
              email: new FormControl('', validateEmail)
            });
          }

          // no list has a list of domains
          else if(!this.hasUserList && this.userListType && this.domainList != false){
            this.form = new FormGroup({
              identifier: new FormControl('', Validators.required),
              email: new FormControl(this.domainList[0].domain)
            });
          }

          //No list of users, no registered domains, no identifiers
          else if(!this.hasUserList && !this.domainList){
            this.form = new FormGroup({
              email: new FormControl('', validateEmail)
            });
          }

          else{
            this.router.navigate(['page-not-found']);
          }

          this.setBackgroundColor(this.responseApis[0]['data']['generalDetails'][0]['background_color']);
          this.backgroundColor = this.responseApis[0]['data']['generalDetails'][0]['background_color'];
          if(!this.route.params['_value'].hash){
            console.log('un');
          }
          else{
            console.log(this.route.params['_value'].hash);
            this.loginUser();
          }
          var m = this;
          setTimeout(function(){
            m.fadeOutLoader = true;
            m.logo = apiUrl + m.responseApis[0]['data']['logo'][0]['path'];
          }, 2000);
        }
      })
      .catch(error => this.error = error);
  }

  postAuthenticate(url: string, username:string): void {
    this.loginService
      .postAuthenticate(url, username)
      .then(responseApi => {
        this.loginAttempt = responseApi;
        var thing = this;
        this.fadeOutLoaderLogin = true;
        setTimeout(function(){

          thing.fadeOutLoaderLogin = false;
          thing.showLoaderLogin = false;
          thing.textError = thing.loginAttempt['msg'];
          if(thing.loginAttempt['success']){
            //localStorage.setItem('auth', thing.loginAttempt['token']);
            localStorage.setItem('hash', thing.loginAttempt['username']);
            thing.router.navigate([thing.route.params['_value'].url+'/questionnaire/'+'policy'+'/1'])
          }
          //this.router.navigate(['page-not-found']);
        }, 1000);

      })
      .catch(error => this.error = error);
  }

  loginUser(){
    if((!this.form.valid && !this.route.params['_value'].hash)){
      this.attemptToSubmit = false;
    }
    else{
      this.attemptToSubmit = true;
      var formValues = this.form.value
      console.log(formValues.email, '__________')
      if(typeof this.route.params['_value'].hash != 'undefined') {
        this.identifierForServer = this.route.params['_value'].hash;
      }
      else{
        if(typeof formValues.identifier == 'undefined'){
          this.identifierForServer = formValues.email;
        }
        else{
          console.log(formValues.email)
          if(formValues.email[0] == '@'){
            console.log(formValues.email)
            this.identifierForServer = formValues.identifier + formValues.email;
          }
          else{
            console.log(formValues.email)
            //this.identifierForServer = formValues.identifier + '@' + formValues.email;
            this.identifierForServer = formValues.identifier;
          }

        }
      }
      this.showLoaderLogin = true;
      this.textError = "";
      console.log(this.identifierForServer);
      this.postAuthenticate(this.route.params['_value'].url, this.identifierForServer);
    }
  }

  ngOnInit(): void {
    console.log(1);
    var hash = localStorage.getItem('hash');
    console.log(typeof hash);

    this.backgroundColor = '#ffffff';
    this.fadeOutLoader = false;
    this.logo = false;
    this.getUrl(this.route.params['_value'].url);



    /*if(typeof hash == null){
     this.backgroundColor = '#ffffff';
     this.fadeOutLoader = false;
     this.logo = false;
     this.getUrl(this.route.params['_value'].url);
     }
     else{
     this.router.navigate(['campaign/'+this.route.params['_value'].url+'/questionnaire/'+'policy'+'/1'])
     }*/
  }
}



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/login-game/login-game.component.ts